import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Slider, {Range} from "rc-slider";
import Tooltip from "rc-tooltip";
import 'rc-slider/assets/index.css';
import ImageOpenAnswer from "../../Components/imageOpenAnswer";
import AnswerContainer from "../../Components/answerContainer";
import classnames from "classnames";
import _ from "lodash";

class PresentationSliders extends Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.getValue = this.getValue.bind(this);
    this.getSlider = this.getSlider.bind(this);
  }

  onChange(value) {
    const {row} = this.props;
    this.props.onRowUpdated(row.id, value);

    this.forceUpdate();
  }

  getValue(){
    const {question, detail} = this.props;

    return detail ? detail.value : (question.defaultValueMiddle ? ((question.scaleSize + 1) / 2) : 0);
  }

  getSlider(vertical) {
    const {detail, question, isError, validate} = this.props;
    const Handle = Slider.Handle;

    const handle = (props) => {
      const { value, dragging, index, ...restProps } = props;

      return (
          <Tooltip
              prefixCls="rc-slider-tooltip"
              overlay={value}
              visible={dragging}
              placement="top"
              key={index}
          >
            <Handle value={value} {...restProps} />
          </Tooltip>
      );
    };

    return <Slider
        className={(!_.isNull(validate) && validate.errors.length > 0) ? "error" : ""}
        handle={handle}
        vertical={vertical}
        min={1}
        reverse={vertical}
        max={question.scaleSize}
        onChange={value => this.onChange(value)}
        value={this.getValue()}
    />;
  }

  render() {
    const {question, row} = this.props;

    return <React.Fragment>
      <div className={"d-flex diff-slider-container"}>
      <AnswerContainer
          classes={"text-center pointer-none font-weight-bold flex-1 diff-instruction"}
          answer={row}
          checked={false}
          component={
            <ImageOpenAnswer
                answer={row.leftContent ? row.leftContent : ""}
                detail={null}
                checkboxType={''}
                answersImage={question.rowsImage}
                showInput={false}
                showContent={true}
                answerOpenAlwaysShow={false}
                leftComponent={<span className={"arrow left position-absolute"}>
                    <i className={"fa-solid fa-arrow-left-long-to-line"}/>
                  </span>}
            />
          }
      />
      <div className={classnames({
        "d-flex d-lg-none flex-1 vertical": true,
        "pl-4 pr-4": true,
        "mt-4 mb-5": true,
        "justify-content-center": true
      })}>
        {this.getSlider(true)}
      </div>
      <div className={classnames({
        "d-none d-lg-flex flex-1": true,
        "pl-5 pr-5": true,
        "mt-0 mb-0": true,
        "justify-content-center": true
      })}>
        {this.getSlider(false)}
      </div>
      <AnswerContainer
          classes={"text-center pointer-none font-weight-bold flex-1 diff-instruction"}
          answer={row}
          checked={false}
          component={
            <ImageOpenAnswer
                answer={row.rightContent ? row.rightContent : ""}
                detail={null}
                checkboxType={''}
                answersImage={question.rowsImage}
                showInput={false}
                showContent={true}
                answerOpenAlwaysShow={false}
                rightComponent={<span className={" arrow right position-absolute"}>
                    <i className={"fa-solid fa-arrow-right-long-to-line"}></i>
                  </span>}
            />
          }
      />
      </div>
    </React.Fragment>
  }
}

PresentationSliders.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  question: PropTypes.shape({
    scaleSize: PropTypes.number.isRequired,
  }).isRequired,
  detail: PropTypes.shape({
    row: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    microTime: PropTypes.number.isRequired,
  }),
  onRowUpdated: PropTypes.func.isRequired,
};

export default PresentationSliders